import React from "react";

function LinkSection() {
  return (
    <section id="links" className="link-section">
      <div className="link-text-heading container">
        <h2>Get In Touch!</h2>
      </div>
      <p className="link-text-content">
        Feel free to reach out and say Hello! I promise I don't bite 😉.
      </p>
      <div className="link-grid container">
        <a
          className="links"
          href="https://www.linkedin.com/in/ambasta-shalu/"
          target="_blank"
          aria-label="LinkedIn Url"
        >
          LinkedIn
        </a>
        <a
          className="links"
          href="https://github.com/ambasta-shalu"
          target="_blank"
          aria-label="GitHub Url"
        >
          GitHub
        </a>
        <a
          className="links"
          href="https://leetcode.com/a-shalu/"
          target="_blank"
          aria-label="LeetCode Url"
        >
          LeetCode
        </a>
        <a
          className="links"
          href="https://auth.geeksforgeeks.org/user/ambasta_shalu/"
          target="_blank"
          aria-label="GeeksForGeeks Url"
        >
          GeeksForGeeks
        </a>
        <a
          className="links"
          href="https://www.hackerrank.com/a_shalu"
          target="_blank"
          aria-label="HackerRank Url"
        >
          HackerRank
        </a>
      </div>
    </section>
  );
}

export default LinkSection;
